import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { Details } from "../../services/doctor.services";
import { ROLE } from "../../../../utils/Constants";
import { SpecializationList } from "../../services/doctor-specialization.services";

const UsersView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const [specialization, setSpecialization] = useState([]);

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: 'Doctor Management',
      url: "/admin/doctor-management/doctor/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];


  useEffect(() => {
    Details(params.id, ROLE.SUPER_ADMIN)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

    useEffect(() => {
      SpecializationList(ROLE.SUPER_ADMIN)
        .then((data) => {
          setSpecialization(data && data.data ? data.data.list : []);
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {/* <div>
                <h6 className="main-content-label mb-3">View Doctor</h6>
              </div> */}
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>Profile Image</th>
                        <td>
                          <img
                            src={
                              showdefault && showdefault.profile_image
                                ? showdefault.profile_image
                                : "N/A"
                            }
                            alt="profile"
                            style={{ height: "100px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th> {t("Doctor ID")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.doctor_register_id
                            ? showdefault.doctor_register_id
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Doctor Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.name ? showdefault.name : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Email")}</th>
                        <td>
                          {showdefault && showdefault.email
                            ? showdefault.email
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Contact Number")}</th>
                        <td>
                          {showdefault && showdefault.phone_number
                            ? capitalizeFirstLetter(showdefault.phone_number)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("DOB")}</th>
                        <td>
                          {showdefault && showdefault?.dob
                            ? formateDate(showdefault.dob)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Gender")}</th>
                        <td>
                          {showdefault && showdefault.gender
                            ? capitalizeFirstLetter(showdefault.gender)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Specialization")}</th>
                        <td>
                          {showdefault?.specialisation?.length > 0 && specialization.length > 0
                            ? showdefault.specialisation
                              .map((id) => {
                                const spec = specialization.find((item) => item._id === id);
                                return spec?.title;
                              })
                              .join(", ")
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Consultation Charge")}</th>
                        <td>
                          {showdefault && showdefault.consultation_charge
                            ? (showdefault.consultation_charge)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Experience(Months)")}</th>
                        <td>
                          {showdefault && showdefault.experience_months
                            ? (showdefault.experience_months)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Experience(Years)")}</th>
                        <td>
                          {showdefault && showdefault.experience_years
                            ? (showdefault.experience_years)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Qualification 1")}</th>
                        <td>
                          {showdefault && showdefault.qualification1
                            ? capitalizeFirstLetter(showdefault.qualification1)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Institute 1")}</th>
                        <td>
                          {showdefault && showdefault.institute1
                            ? capitalizeFirstLetter(showdefault.institute1)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Qualification 2")}</th>
                        <td>
                          {showdefault && showdefault.qualification2
                            ? capitalizeFirstLetter(showdefault.qualification2)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Institute 2")}</th>
                        <td>
                          {showdefault && showdefault.institute2
                            ? capitalizeFirstLetter(showdefault.institute2)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Document Link")}</th>
                        <td>
                          {showdefault && showdefault.document ? (
                            <a href={showdefault.document} target="_blank" rel="noopener noreferrer">
                              {"View Document"}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                      </tr>
                      {
                        showdefault.centers.map(centerDetails =>
                          <>
                            <tr>
                              <th>Center Id</th>
                              <td>
                                {centerDetails && centerDetails?.center?.center_register_id
                                  ? centerDetails?.center?.center_register_id
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>Center Name</th>
                              <td>
                                {centerDetails && centerDetails?.center?.name
                                  ? capitalizeFirstLetter(centerDetails?.center?.name)
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("Start Time")}</th>
                              <td>
                                {centerDetails && centerDetails.start_available_time
                                  ? centerDetails.start_available_time
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("End Time")}</th>
                              <td>
                                {centerDetails && centerDetails.end_available_time
                                  ? centerDetails.end_available_time
                                  : "N/A"}
                              </td>
                            </tr>
                          </>
                        )
                      }
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersView;
